import { subscribeToRouter, currentUser, onUserChange } from './common'
import posthog from 'posthog-js'

let isEnabled = false

export function trackEvent(category, action, properties) {
  if (!isEnabled) {
    return
  }
  posthog.capture(action, { category, ...properties })
}

export function enable(host, apiKey) {
  posthog.init(apiKey, {
    api_host: host,
    autocapture: false
  })

  subscribeToRouter(url => {
    posthog.capture('$pageview', { $current_url: url })
  })

  const updateUser = (user, created) => {
    if (user) {
      if (created) {
        posthog.alias(user.id)
      } else {
        posthog.identify(user.id)
      }
      posthog.people.set({
        workFunction: user.workFunction,
        workLevel: user.workLevel
      })
    }
  }

  updateUser(currentUser())

  onUserChange(({ user, created }) => {
    if (user) {
      updateUser(user, created)
    } else {
      posthog.reset()
    }
  })

  isEnabled = true
}
